
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, MessageSquare, User, List, TrendingUp, Briefcase } from 'lucide-react';
import { useAppContext } from '../../App.jsx';
import { COLORS } from '../../config/constants';

const BottomNav = ({ userRole: propRole }) => {
    const location = useLocation();
    const { notificationCount, activeRole: contextRole } = useAppContext();
    const activeRole = propRole || contextRole;

    const navItems = activeRole === 'client'
        ? [
            { path: '/', icon: Home, label: 'Início' },
            { path: '/chats', icon: MessageSquare, label: 'Chats' },
            { path: '/client/appointments', icon: List, label: 'Serviços', relatedPaths: ['/proposals'] },
            { path: '/profile', icon: User, label: 'Perfil' },
        ]
        : [
            { path: '/servi/dashboard', icon: Briefcase, label: 'Serviços' },
            { path: '/chats', icon: MessageSquare, label: 'Chats' },
            { path: '/servi/fluxo', icon: TrendingUp, label: 'Fluxo', relatedPaths: ['/proposals', '/servi/academy'] },
            { path: '/profile', icon: User, label: 'Perfil' },
        ];

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white shadow-top z-40 max-w-lg mx-auto border-t border-gray-100" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
            <div className="flex justify-around items-center h-16">
                {navItems.map(({ path, icon: Icon, label, relatedPaths = [] }) => {
                    const isActive = location.pathname === path || relatedPaths.includes(location.pathname);
                    const itemColor = isActive ? COLORS.ACTION_BLUE : COLORS.NEUTRAL_GRAY;

                    return (
                        <Link
                            to={path}
                            key={path}
                            className={`relative flex flex-col items-center justify-center w-full h-full text-center p-1 transition-all duration-200 ${isActive ? 'scale-110' : 'opacity-70'}`}>
                           {label === 'Perfil' && notificationCount > 0 && (
                               <span className="absolute top-2 right-1/2 translate-x-4 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
                           )}
                           <Icon style={{ color: itemColor }} className="w-6 h-6 mb-0.5" />
                           <span className="text-[10px] font-bold uppercase tracking-tighter" style={{ color: itemColor }}>
                                {label}
                           </span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default BottomNav;
